import axios, { AxiosResponse } from "axios";

const getTagsLIstSeach = async (q: string) => {
  try {
    const { data }: AxiosResponse<any> = await axios.get(
      `${
        //@ts-ignore
        window?.ENV.APIURL || "https://api.ru-digital.de/api/v2"
      }/media/filters/tags`,
      {
        params: { q: q },
        headers: {
          forcePayload: true,
          Authorization: "Basic dm9pZG1vZDp2ZDIwMjE=",
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );

    return data;
  } catch (e) {
    console.log(e);
  }
};

export default getTagsLIstSeach;
